import { FormattedMessage, useIntl } from 'react-intl';
import { type ReactNode } from 'react';
import { type BaseButtonProps, Button } from '@repo/design-system-kit/components/button/button';
import IconArrowLeftOutlined from '@repo/monochrome-icons/icon-arrow-left-outlined';
import styles from './back-button.module.css';

export function BackButton({ ...props }: Omit<BaseButtonProps, 'children'>): ReactNode {
  const { formatMessage } = useIntl();

  return (
    <Button
      aria-label={formatMessage({ id: 'generic.back.cta' })}
      data-test-back-button
      type="button"
      variant="tertiary"
      {...props}
    >
      <IconArrowLeftOutlined className={styles.icon} />
      <FormattedMessage id="generic.back.cta" />
    </Button>
  );
}
